/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_B_To_A_TitleInputs */

const en_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply changes from Group B to Group A`)
};

const fr_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer les modifications du groupe B au groupe A`)
};

const de_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen von Gruppe B auf Gruppe A übertragen`)
};

const it_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica le modifiche dal Gruppo B al Gruppo A`)
};

const ru_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перенесите изменения из группы B в группу A.`)
};

const es_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar cambios del Grupo B al Grupo A`)
};

const zh_cn2_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将B组的变更应用于A组。`)
};

const ja_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループBからグループAに変更を適用する`)
};

const hi_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह B से समूह A में परिवर्तन लागू करें`)
};

const pt_pt2_compare_event_groups_apply_b_to_a_title = /** @type {(inputs: Compare_Event_Groups_Apply_B_To_A_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar as alterações do Grupo B ao Grupo A.`)
};

/**
* | output |
* | --- |
* | "Apply changes from Group B to Group A" |
*
* @param {Compare_Event_Groups_Apply_B_To_A_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_b_to_a_title = /** @type {((inputs?: Compare_Event_Groups_Apply_B_To_A_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_B_To_A_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_apply_b_to_a_title(inputs)
	if (locale === "de") return de_compare_event_groups_apply_b_to_a_title(inputs)
	if (locale === "it") return it_compare_event_groups_apply_b_to_a_title(inputs)
	if (locale === "ru") return ru_compare_event_groups_apply_b_to_a_title(inputs)
	if (locale === "es") return es_compare_event_groups_apply_b_to_a_title(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_apply_b_to_a_title(inputs)
	if (locale === "ja") return ja_compare_event_groups_apply_b_to_a_title(inputs)
	if (locale === "hi") return hi_compare_event_groups_apply_b_to_a_title(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_apply_b_to_a_title(inputs)
	return en_compare_event_groups_apply_b_to_a_title(inputs)
});